import React, { useEffect } from "react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  RefreshIcon,
} from "@heroicons/react/solid";
import { useNavigate } from "react-router-dom";
import useState from "react-usestateref";
import axios from "axios";
import { toast } from "react-toastify";
import toastProp from "../global/toastProps";
import ReactCodeInput from "react-code-input";

const maskEmail = (mail) => {
  var splitEmail = mail.split("@");
  var domain = splitEmail[1];
  var name = splitEmail[0];
  return name.substring(0, 3).concat("*********@").concat(domain);
};
function ForgotPasswordScreen() {
  const [otp, setOTP] = useState(false);
  const [otpCode, setOTPCode] = useState("");
  const [email, setEmail] = useState("");
  const [userID, setUserID] = useState("");
  const [changePassword, setChangePassword] = useState(false);
  const [password, setPassword, passwordRef] = useState("");
  const [passwordIsValid, setPasswordIsValid, passwordIsValidRef] =
    useState(true);
  const [confirmPassword, setConfirmPassword, confirmPasswordRef] =
    useState("");
  const [
    confirmPasswordIsValid,
    setConfirmPasswordIsValid,
    confirmPasswordIsValidRef,
  ] = useState(true);
  const [counter, setCounter] = useState(10);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const passwordValidation = () => {
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/i;
    if (passwordRegex.test(passwordRef.current)) {
      setPasswordIsValid(true);
    } else {
      setPasswordIsValid(false);
    }
  };
  const confirmPasswordValidation = () => {
    if (passwordRef.current === confirmPasswordRef.current) {
      setConfirmPasswordIsValid(true);
    } else {
      setConfirmPasswordIsValid(false);
    }
  };

  const handlesubmit = async (e) => {
    if (email.length !== 0) {
      e.preventDefault();
      setLoading(true);
      const id = toast.loading("Please wait...", { theme: "light" });
      try {
        toast.update(id, {
          render: "Sending OTP...",
          isLoading: true,
          theme: "light",
        });
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/email`,
          JSON.stringify({ email }),
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        setUserID(response.data["ID"]);
        // toast.success("Email sent successfully");
        toast.update(id, toastProp("OTP sent successfully", true));
        setOTP(true);
        setCounter(60);
        setLoading(false);
      } catch (error) {
        toast.update(id, toastProp(error.response.data["Status"], false));
        console.log(error.response);
        setLoading(false);
      }
    }
  };
  const handleOTP = async (e) => {
    if (otpCode.length !== 0) {
      e.preventDefault();
      setLoading(true);
      const id = toast.loading("Please wait...", { theme: "light" });
      try {
        toast.update(id, {
          render: "Verifying OTP...",
          isLoading: true,
          theme: "light",
        });
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/verify`,
          JSON.stringify({ email, otpcode: otpCode }),
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        toast.update(id, toastProp("OTP verified successfully", true));
        setChangePassword(true);
        setLoading(false);
      } catch (error) {
        toast.update(id, toastProp(error.response.data["Status"], false));
        setLoading(false);
      }
    }
  };
  const handlePass = async (e) => {
    if (password.length !== 0) {
      e.preventDefault();
      setLoading(true);
      const id = toast.loading("Please wait...", { theme: "light" });
      try {
        toast.update(id, {
          render: "Changing password...",
          isLoading: true,
          theme: "light",
        });
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/newpass`,
          JSON.stringify({ email, otpcode: otpCode, password }),
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        toast.update(id, toastProp("Password changed successfully", true));
        navigate("/login");
        setLoading(false);
      } catch (error) {
        toast.update(id, toastProp(error.response.data["Status"], false));
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);
 

  return (
    <>
      {otp ? (
        <div className="h-screen m-0 bg-background flex justify-center">
          <div className="flex flex-col items-center justify-center shadow-md shadow-black rounded-2xl p-[3%] m-5">
            {changePassword ? (
              // Change Password
              <div>
                <h2 className="text-primary font-robo  text-center text-4xl">
                  Change Password
                </h2>
                <form action="#" method="POST">
                  <div className="col-span-6 sm:col-span-3 ">
                    <div className="w-[100%]">
                      <label className="block text-md font-robo text-primary  mt-3">
                        New Password
                        <span className="text-red"> *</span>
                      </label>
                      <input
                        type="password"
                        name="new-password"
                        id="new-password"
                        required
                        className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                        placeholder="Enter new Password"
                        onChange={(e) => {
                          setPassword(e.target.value);
                          passwordValidation();
                        }}
                      />
                      {/* Implement logic on h3 to show/hide error message */}
                      {!passwordIsValidRef.current ? (
                        <h3 className="text-sm  text-red font-robo ">
                          * Password must contain atleast 8 <br />
                          characters, atleast 1 number & 1 letter
                        </h3>
                      ) : null}
                      <label className="block text-md font-robo text-primary  mt-3">
                        Confirm Password
                        <span className="text-red"> *</span>
                      </label>
                      <input
                        type="password"
                        name="confirm-newPassword"
                        id="confirm-newPassword"
                        required
                        className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                        placeholder="Confirm Password"
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          confirmPasswordValidation();
                        }}
                      />
                      {/* Implement logic on h3 to show/hide error message */}
                      {!confirmPasswordIsValidRef.current ? (
                        <h3 className="text-sm  text-red font-robo ">
                          * Password must be same
                        </h3>
                      ) : null}
                      <div className="mt-10 text-right">
                        <button
                          type="submit"
                          className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                          onClick={async (e) => {
                            if (
                              passwordIsValidRef.current &&
                              confirmPasswordIsValidRef.current
                            ) {
                              console.log("in if");
                              await handlePass(e);
                            } else {
                              console.log("in else");
                              e.preventDefault();
                            }
                          }}
                          disabled={loading ? true : false}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              // OTP
              <div>
                <ArrowLeftIcon
                  className="h-6 w-6 my-1 mx-1 text-palette_color1 cursor-pointer"
                  aria-hidden="true"
                  onClick={() => setOTP(false)}
                />
                <div>
                  <h2 className="text-primary font-robo  text-center text-4xl ">
                    OTP Verification
                  </h2>
                  <h1 className="pt-3 text-md font-robo text-secondary text-center ">
                    Enter the OTP sent to your email <br />
                    {maskEmail(email)}
                  </h1>

                  <div className="col-span-6 sm:col-span-3 ">
                    <div className="w-[100%]">
                      <label className="block text-md text-primary font-robo  mt-3">
                        OTP
                        <span className="text-red"> *</span>
                      </label>
                      {/* <input
                          type="text"
                          name="otp"
                          id="otp"
                          className="appearance-none rounded relative block w-full px-3 py-2 border border-gray-400 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:border-green-500 focus:z-10 sm:text-sm my-1"
                          placeholder="Enter OTP"
                          value={otpCode}
                          required
                          onChange={(e) => setOTPCode(e.target.value)}
                        /> */}
                      <div className="flex w-[100%] justify-center align-middle">
                        <ReactCodeInput
                          type="text"
                          fields={6}
                          required
                          value={otpCode}
                          onChange={(e) => setOTPCode(e)}
                        />
                      </div>
                      {/* If OTP is incorrect implement logic on h3 to show/hide error message */}
                      <h3 className="text-xl text-center font-robo text-secondary mt-3 ">
                        Resend OTP in 00:
                        <span
                          className={`${
                            counter < 10
                              ? "text-red-400"
                              : "text-palette_color4"
                          }`}
                        >
                          {counter < 10 ? "0" + counter : counter}
                        </span>
                      </h3>
                      <div className="flex justify-between items-center">
                        <div className=" text-left">
                          {counter === 0 && (
                            <button
                              type="submit"
                              className="flex justify-center text-xl font-robo text-palette_color1 hover:underline focus:outline-none"
                              onClick={handlesubmit}
                            >
                              <span>
                                <RefreshIcon
                                  className="h-5 w-5 my-1 mx-2 "
                                  aria-hidden="true"
                                />
                              </span>
                              Resend
                            </button>
                          )}
                        </div>
                        <div className="py-10 text-right">
                          <button
                            type="submit"
                            className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                            onClick={handleOTP}
                            disabled={loading ? true : false}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        // Email
        <div className="h-screen m-0 bg-background flex justify-center">
          <div className="shadow-md shadow-black rounded-2xl p-[3%] flex justify-center items-center m-3">
            <div>
              <h2 className="text-primary font-robo  text-center text-4xl ">
                Account Recovery
              </h2>
              <h1 className="pt-3 text-md font-robo text-secondary  text-center">
                Enter the email associated with this account
              </h1>
              <form action="#" method="POST">
                <div className="col-span-6 sm:col-span-3 ">
                  <div className="w-[100%]">
                    <label className="block text-md font-robo text-primary  mt-3">
                      Email
                      <span className="text-red"> *</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email-address"
                      autoComplete="email"
                      required
                      className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                      placeholder="Email Address"
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                    {/* If email is incorrect implement logic on h3 to show/hide error message */}
                    <div className=" flex justify-end md:justify-between">
                      <div
                        className="hidden md:flex md:py-12 md:text-left"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/login");
                        }}
                      >
                        <button
                          type="submit"
                          className="flex justify-center text-xl font-robo text-palette_color1 hover:underline focus:outline-none "
                        >
                          <span>
                            <ArrowLeftIcon
                              className="h-5 w-5 my-1 mx-1 "
                              aria-hidden="true"
                            />
                          </span>
                          Back
                        </button>
                      </div>
                      <div className="py-10 text-right">
                        <button
                          type="submit"
                          className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                          onClick={handlesubmit}
                          disabled={loading ? true : false}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ForgotPasswordScreen;
